import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { usuariosService } from './services/usuariosService';
import type { FiltrosUsuarios } from './types/Usuario';

export const usuariosQueries = {
  all: () => ['usuarios'] as const,
  lista: (filtros: FiltrosUsuarios) =>
    queryOptions({
      queryKey: [...usuariosQueries.all(), 'lista', filtros] as const,
      queryFn: () => usuariosService.listar(filtros),
      placeholderData: keepPreviousData,
    }),
};
